import { isProduction } from "./env";

/**
 * Wraps console.log, but logs only in not-production environments.
 */
export function debug(...args) {
  if (!isProduction()) {
    console.log(...args);
  }
}

/**
 * Creates a function wrapping console.log that will log only once per
 * change in its arguments, and only in development mode.
 * In non-development environments the returned function is a noop.
 */
debug.createLogOnce = function createLogOnce() {
  if (!isProduction()) {
    let logged = false;
    let lastArgs;
    return function (...args) {
      if (!logged || JSON.stringify(args) !== lastArgs) {
        logged = true;
        lastArgs = JSON.stringify(args);
        console.log(...args);
      }
    };
  }

  return () => {};
};
/**
 * Wraps console.error, but logs only in not-production environments.
 */
debug.error = function error(...args) {
  if (!isProduction()) {
    console.error(...args);
  }
};
